<div class="aem-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="aem-modal" (click)="$event.stopPropagation()">
    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="aem-header">
      <div class="aem-header__left">
        <div class="aem-header__icon-wrap">
          <img
            src="assets/performance/air-emissions.svg"
            alt="Air Emissions"
            class="aem-header__icon"
          />
        </div>
        <h2 class="aem-header__title">Air Emissions</h2>
      </div>
      <div class="aem-header__actions">
        <button
          class="aem-header__btn"
          [title]="'REPORT_DASHBOARD.DOWNLOAD' | translate"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </button>
        <button
          class="aem-header__btn aem-header__btn--close"
          (click)="close()"
          [title]="'ADD_QR.BTN_CLOSE' | translate"
        >
          ✕
        </button>
      </div>
    </div>

    <div class="aem-header-divider"></div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="aem-body">
      <!-- ── Left Column ──────────────────────────────────────────── -->
      <div class="aem-col aem-col--left">
        <!-- AI Text Box -->
        <div class="aem-ai-box">
          <p class="aem-ai-box__text">
            {{ aiText || "AI Generated — No summary available." }}
          </p>
        </div>

        <!-- Air Emissions Table Card -->
        <div class="aem-table-card">
          <div class="aem-table-card__head">
            <div class="aem-table-card__head-icon">
              <img src="assets/performance/air-emissions.svg" alt="" />
            </div>
            <div>
              <p class="aem-table-card__title">Air Emissions</p>
              <p class="aem-table-card__sub">
                {{ "PLANTS_WITH_GE_7_DAYS_OF_EXCEEDANCE_WITHIN_A_MONTH_LAST_90_DAYS" | translate }}
              </p>
            </div>
          </div>

          <div class="aem-table-scroll">
            <table class="aem-table">
              <thead>
                <tr>
                  <th class="aem-table__th aem-table__th--left">
                    {{ "SHIELD.UNIT" | translate }}
                  </th>
                  <th class="aem-table__th aem-table__th--red">Dust</th>
                  <th class="aem-table__th aem-table__th--red">NOx</th>
                  <th class="aem-table__th aem-table__th--red">
                    SO
                    <sub>2</sub>
                  </th>
                  <th class="aem-table__th">
                    {{ "PERFORMANCE.MONTH" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableRows" class="aem-table__tr">
                  <td
                    class="aem-table__td aem-table__td--left"
                    [class.aem-table__td--exceeded]="(row.dust ?? 0) >= 150"
                  >
                    {{ row.plantName }}
                  </td>
                  <td
                    class="aem-table__td"
                    [class.aem-table__td--exceeded]="(row.dust ?? 0) >= 150"
                  >
                    {{ row.dust !== null ? row.dust + "%" : "—" }}
                  </td>
                  <td
                    class="aem-table__td"
                    [class.aem-table__td--exceeded]="(row.nox ?? 0) >= 150"
                  >
                    {{ row.nox !== null ? row.nox + "%" : "—" }}
                  </td>
                  <td
                    class="aem-table__td"
                    [class.aem-table__td--exceeded]="(row.so2 ?? 0) >= 150"
                  >
                    {{ row.so2 !== null ? row.so2 + "%" : "—" }}
                  </td>
                  <td class="aem-table__td">{{ row.monthName }}</td>
                </tr>
                <tr *ngIf="tableRows.length === 0">
                  <td colspan="5" class="aem-table__empty">
                    {{ "NO_EXCEEDANCE_DATA_AVAILABLE" | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="aem-table-card__footer">
            Days since last Exceedance
            <strong>{{ daysSinceExceedance }}</strong>
          </p>
        </div>
      </div>

      <!-- ── Right Column ─────────────────────────────────────────── -->
      <div class="aem-col aem-col--right">
        <!-- Sensor Issues Card -->
        <div class="aem-rc">
          <div class="aem-rc__header">
            <div class="aem-rc__icon-wrap">
              <img
                src="assets/performance/sensor-issues.svg"
                alt="Sensor Issues"
                class="aem-rc__icon"
              />
            </div>
            <div class="aem-rc__header-text">
              <p class="aem-rc__title">Sensor Issues</p>
              <p class="aem-rc__sub">{{ "LAST_30_DAYS" | translate }}</p>
            </div>
          </div>

          <div class="aem-rc__divider"></div>

          <ng-container *ngIf="sensorIssues.length > 0; else noSensorData">
            <div class="aem-rc__bar-list">
              <div *ngFor="let s of sensorIssues" class="aem-rc__bar-item">
                <div class="aem-rc__bar-top">
                  <span class="aem-rc__bar-name">{{ s.name }}</span>
                  <span class="aem-rc__bar-count">{{ s.count }}</span>
                </div>
                <div class="aem-rc__bar-track">
                  <div
                    class="aem-rc__bar-fill"
                    [style.width.%]="sensorBarWidth(s.count)"
                  ></div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noSensorData>
            <div class="aem-rc__no-data">No record found</div>
          </ng-template>
        </div>

        <!-- Recycled Waste Card -->
        <div class="aem-waste-card">
          <img
            src="assets/performance/recycled-waste.svg"
            alt=""
            class="aem-waste-card__icon"
          />
          <div class="aem-waste-card__content">
            <div class="aem-waste-card__top">
              <span class="aem-waste-card__title">Recycled Waste</span>
              <span class="aem-waste-card__pct">{{ recycledWastePct }}%</span>
            </div>
            <div class="aem-waste-card__track">
              <div
                class="aem-waste-card__fill"
                [style.width.%]="recycledWastePct"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
